import styled from 'styled-components';

const CallToActionContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 0;
  background-color: #f0f0f0; /* Light gray background */
`;

const CallToActionBtn = styled.a`
  background-color: #007bff; /* Blue button color */
  color: #fff; /* White button text */
  padding: 1rem 2rem;
  border: none;
  border-radius: 5px;
  font-size: 1.2rem;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: #0069d9; /* Darker blue on hover */
  }
`;

const CallToAction = () => {
  return (
    <CallToActionContainer id="contact">
      <CallToActionBtn
      href="mailto:contact@tech2us.ma?subject=Potential Collaboration / Partnership Inquiry&body=Salaam, I am interested in your services, thank you for accepting my membership request."
      >Get Started Today</CallToActionBtn>
    </CallToActionContainer>
  );
};

export default CallToAction;
